// extracted by extract-css-chunks-webpack-plugin
module.exports = {"restriction-info":"restrictioninfo__restriction-info--UkoRd","restrictionInfo":"restrictioninfo__restriction-info--UkoRd","list":"restrictioninfo__list--2BoBn"};